var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumb"
  }, [_c('ul', _vm._l((_vm.breadcrumbList), function(breadcrumb, idx) {
    return _c('li', {
      key: idx,
      class: {
        'linked': !!breadcrumb.link
      },
      on: {
        "click": function($event) {
          return _vm.routeTo(idx)
        }
      }
    }, [_vm._v("\n\n      " + _vm._s(breadcrumb.name) + "\n\n    ")])
  }), 0)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d03636","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 547
// module chunks = 1